<template>
  <div ref="AssessorFeedbackDocument" id="AssessorFeedbackDocument "> 
    <div class="mt-3 AssessorPopUp" v-if="assessorFeedbackData">
      <div class="Review-Dimensions mb-2">
        <table class="outcome">
          <tr>
            <td class="outcome-heading outcome-headers"><h6 style="padding-right:5px"><strong>Programme</strong></h6></td>
            <td style="padding: 10px;"><h6>{{assessorFeedbackData.programme}}</h6></td>
          </tr>
          <tr>
            <td class="outcome-heading outcome-headers"><h6 style="padding-right:5px"><strong>Unit Standard</strong></h6></td>
            <td style="padding: 10px;"><h6>{{assessorFeedbackData.unitStandard}}</h6></td>
          </tr>
        </table>
        <table class="outcome">
          <tr>
            <td class="outcome-heading outcome-headers"><h6 style="padding-right:5px"><strong>Assessor Name</strong></h6></td>
            <td style="padding: 10px;"><h6>{{assessorFeedbackData.assessorName}}</h6></td>
            <td class="outcome-heading outcome-headers"><h6 style="padding-right:5px"><strong>Assessor Number</strong></h6></td>
            <td style="padding: 10px;"><h6>{{assessorFeedbackData.assessorNumber}}</h6></td>
          </tr>
          <tr>
            <td class="outcome-heading outcome-headers"><h6 style="padding-right:5px"><strong>Moderator Name</strong></h6></td>
            <td style="padding: 10px;"><h6>{{assessorFeedbackData.moderatorName}}</h6></td>
            <td class="outcome-heading outcome-headers"><h6 style="padding-right:5px"><strong>Moderator Number</strong></h6></td>
            <td style="padding: 10px;"><h6>{{assessorFeedbackData.moderatorNumber}}</h6></td>
          </tr>
          <tr>
            <td class="outcome-heading outcome-headers"><h6 style="padding-right:5px"><strong>Learner Name</strong></h6></td>
            <td style="padding: 10px;"><h6>{{taskResults.fullname}}</h6></td>
            <td class="outcome-heading outcome-headers"><h6 style="padding-right:5px"><strong>Learner ID</strong></h6></td>
            <td style="padding: 10px;"><h6>{{assessorFeedbackData.learnerId}}</h6></td>
          </tr>
        </table>
        <table class="outcome" >
          <tr>
            <td class="darkblue"><h4>First Assessment Outcome</h4></td>
          </tr>
        </table>
        <table class="outcome" >
          <tr>
            <td class="tableblue smallerWidth"><h6 style="padding:5px"><strong>Competent</strong></h6></td>
            <td class="smallerWidth" style="text-align:center;"><feather-icon v-if="assessorFeedback.isCompetent" icon="CheckIcon" svgClasses="h-4 w-4"/></td>
            <td class="tableblue smallerWidth"><h6 style="padding:5px"><strong>Not Yet Competent</strong></h6></td>
            <td class="smallerWidth" style="text-align:center;"><feather-icon v-if="!assessorFeedback.isCompetent" icon="XIcon" svgClasses="h-4 w-4"/></td>
            <td class="tableblue smallerWidth"><h6 style="padding:5px"><strong>Date</strong></h6></td>
            <td style="padding: 5px;">{{displayDate(assessorFeedbackData.assessorSignatureDate)}}</td>
          </tr>
        </table>
        <table class="outcome">
          <tr>
            <td class="tableblue smallerWidth signatures"><h6 style="padding:5px"><strong>Signatures</strong></h6></td>
              <td>
                <div class="split">
                  <div class="signature">
                    <img :src="assessorFeedbackData.assessorSignature" alt="">
                    <p>{{displayDate(assessorFeedbackData.assessorSignatureDate)}}</p>
                  </div>
                  <div class="tableblue">
                    <h6 class="tableblue text-center" style="padding:5px;padding-bottom:10px; margin:0px;border-top:2px solid black">
                      <strong>Assessor Signature</strong>
                    </h6>
                  </div>
                </div>
              </td>
              <td>
                <div class="split">
                  <div class="signature">
                    <img :src="assessorFeedbackData.moderatorSignature" alt="">
                    <p>{{displayDate(assessorFeedbackData.moderatorSignatureDate)}}</p>
                  </div>
                  <div class="tableblue">
                    <h6 class="tableblue text-center" style="padding:5px;padding-bottom:10px; margin:0px;border-top:2px solid black">
                      <strong>Moderator Signature and Date</strong>
                    </h6>
                  </div>
                </div>
              </td>
              <td>
                <div class="split">
                  <div class="signature">
                    <img :src="assessorFeedbackData.learnerSignature" alt="">
                    <p>{{displayDate(assessorFeedbackData.learnerSignatureDate)}}</p>
                  </div>
                  <div class="tableblue">
                    <h6 class="tableblue text-center" style="padding:5px;padding-bottom:10px; margin:0px; border-top:2px solid black">
                      <strong>Learner Signature and Date</strong>
                    </h6>
                  </div>
                </div>
              </td>
          </tr>
        </table>
        <table class="outcome bottomborder">
          <tr class="lastrow">
            <td style="padding:5px; vertical-align: baseline" class="tableblue smallerWidth"><strong>Assessor Declaration and Feedback</strong></td>
            <td class="innertable">
              <div class="p-2">
                <h6>The learner<strong v-html="assessorFeedbackData.submittedAll ? ` (<u>has</u>/has not)`:` (has/<u>has not</u>)`"></strong> submitted all the required evidence (formative and summative assessments).</h6>
                <h6>Feedback:</h6>
                <div>
                  <table class="w-full innertableData">
                    <tr class="tableblue">
                      <th >
                        Learner needs to do:
                      </th>
                      <th class="competency">
                        C
                      </th>
                      <th class="competency">
                        NYC
                      </th>
                    </tr>
                  </table>
                  <table class="w-full innertableData outcome">
                    <tr>
                      <td class="tableblue smallerWidth">Quizzes</td>
                      <td>{{assessorFeedback.hasCompletedQuizzes ? `Completed` : `Not Yet Completed`}}</td>
                      <td class="competency">{{assessorFeedback.hasCompletedQuizzes ? `C` : ``}}</td>
                      <td class="competency">{{assessorFeedback.hasCompletedQuizzes ? `` : `NYC`}}</td>
                    </tr>
                    <tr>
                      <td class="tableblue smallerWidth">Journals & Case Studies</td>
                      <td>{{assessorFeedback.hasCompletedJournals ? `Completed` : `Not Yet Completed`}}</td>
                      <td class="competency">{{assessorFeedback.hasCompletedJournals ? `C` : ``}}</td>
                      <td class="competency">{{assessorFeedback.hasCompletedJournals ? `` : `NYC`}}</td>
                    </tr>
                    <tr>
                      <td class="tableblue smallerWidth">Workplace Logbook</td>
                      <td>{{assessorFeedback.hasCompletedLogbook ? `Completed` : `Not Yet Completed`}}</td>
                      <td class="competency">{{assessorFeedback.hasCompletedLogbook ? `C` : ``}}</td>
                      <td class="competency">{{assessorFeedback.hasCompletedLogbook ? `` : `NYC`}}</td>
                    </tr>
                  </table>
                  <table class="w-full outcome innertableData bottomborder">
                    <tr class="lastrow">
                      <td class="tableblue smallerWidth"><h6>Assessment docs included(  <feather-icon icon="CheckIcon" svgClasses="h-4 w-4"/>or<feather-icon icon="XIcon" svgClasses="h-4 w-4"/>)</h6></td>
                      <td style="padding:0px; border:0px solid">
                        <div class="fourwaySplit grid-container">
                          <div style="height: 50px;" class="grid-item">
                            <h6>Learner’s Personal Information</h6>
                            <feather-icon :icon="assessorFeedback.hasCompletedPersonalInfo ? 'CheckIcon':'XIcon' " svgClasses="h-4 w-4"/>
                          </div>
                          <div style="height: 50px;" class="grid-item">
                            <h6>Assessment Preparation</h6>
                            <feather-icon :icon="assessorFeedback.hasCompletedAssessmentPrep ? 'CheckIcon':'XIcon' " svgClasses="h-4 w-4"/>
                          </div> 
                          <div style="height: 50px;" class="grid-item">
                            <h6>Assessment Plan</h6>
                            <feather-icon :icon="assessorFeedback.hasCompletedAssessmentPlan ? 'CheckIcon':'XIcon' " svgClasses="h-4 w-4"/>
                          </div>
                          <div style="height: 50px;" class="grid-item">
                            <h6>Declaration of Authenticity</h6>
                            <feather-icon :icon="assessorFeedback.hasCompletedDeclarationofAuth ? 'CheckIcon':'XIcon' " svgClasses="h-4 w-4"/>

                          </div>
                        </div>
                      </td>
                    </tr>
                    
                  </table>
                  <h6>Notes:</h6>
                  <p>Please complete the <strong>Learner’s Review of the Assessment Process</strong> document in this feedback document </p>
                </div>
              </div>
            </td>
          </tr>
        </table>
      </div>
      <div class="Review-Dimensions mb-2 mt-5 ">
        <table class="outcome bottomborder td-padding">
          <tr>
            <td class="tableblue smallerWidth" style="padding:5px;"><h6><strong>Programme</strong></h6></td>
            <td>{{assessorFeedbackData.programme}}</td>
          </tr>
          <tr>
            <td class="tableblue smallerWidth" style="padding:5px;"><h6><strong>Unit Standard</strong></h6></td>
            <td>{{assessorFeedbackData.unitStandard}}</td>
          </tr>
          <tr>
            <td class="tableblue smallerWidth" style="padding:5px;"><h6><strong>Assessor</strong></h6></td>
            <td>{{assessorFeedbackData.assessorName}}</td>
          </tr>
          <tr>
            <td class="tableblue smallerWidth" style="padding:5px;"><h6><strong>Learner</strong></h6></td>
            <td>{{taskResults.fullname}}</td>
          </tr>
        </table>
        <table v-if="questionList.length" style="width:100%;" class="Review-Dimensions-true">
          <tr>
            <th><h4>Review Dimensions</h4></th>
            <th><h5 style="width: 105px;" >Agree(<feather-icon icon="CheckIcon" svgClasses="h-4 w-4"/>)</h5></th>
            <th><h5 style="width: 130px;">Disagree(<feather-icon icon="XIcon" svgClasses="h-4 w-4"/>)</h5></th>
          </tr>
          <tr v-for="(question , questionIndex) in questionList.filter(x=>x.id <10)" :key="questionIndex">
            <td class="first-header-data" v-if="question.id <10" ><h6 style="padding-right:5px"><strong>{{`${question.id}. `}}</strong></h6><h6>{{question.question}}</h6></td>
            <td style="text-align:center" v-if="question.id <10" ><feather-icon v-if="assessorFeedback.assessorFeedbackAnswers[questionIndex].agree" icon="CheckIcon" svgClasses="h-4 w-4"/></td>
            <td style="text-align:center" v-if="question.id <10" ><feather-icon v-if="!assessorFeedback.assessorFeedbackAnswers[questionIndex].agree" icon="XIcon" svgClasses="h-4 w-4"/></td>
          </tr>
        </table>
        <table v-if="questionList" style="width: 100%; border-top:0px;" class="Review-Dimensions-free outcome">
          <tr v-for="(question , questionIndex) in questionList.filter(x=>x.id >=10)" :key="questionIndex">
            <td v-if="question.id >=10" :style="questionIndex == 0 ? 'border-top:0px' : '' ">
              <div class="flex">
                <h6 style="padding-right:5px"><strong>{{`${question.id}. `}}</strong></h6><h6>{{`${question.question}`}}</h6> 
              </div>
              <p style="padding-left: 23px;">{{assessorFeedback.assessorFeedbackAnswers[questionIndex +9].answer}}</p>
            </td>
          </tr>
        </table>
        <table class="outcome">
          <tr>
            <th class="tableblue" style="padding:5px"><h6><strong>Learner’s declaration of understanding</strong></h6></th>
          </tr>
          <tr>
            <td style="padding:5px">I am aware that the assessor will provide me with feedback about the assessment and of the moderation process and understand that the moderator could declare the assessment decision invalid. </td>
          </tr>
        </table>
        <table class="outcome">
          <tr>
            <td>
              <div>
                <div class="space"><img :src="assessorFeedbackData.learnerSignature" alt=""><p>{{displayDate(assessorFeedbackData.learnerSignatureDate)}}</p></div>
                <div style="padding:5px; border-top:2px solid; border-bottom:2px solid;text-align:center" class="tableblue">
                  <h6 >Learner Signature and Date </h6>
                </div>
              </div>
            </td>
            <td>
              <div>
                <div class="space">
                  <img :src="assessorFeedbackData.assessorSignature" alt="">
                  <p>{{displayDate(assessorFeedbackData.assessorSignatureDate)}}</p>
                </div>
                <div style="padding:5px; border-top:2px solid; border-bottom:2px solid; text-align:center" class="tableblue">
                  <h6 >Assessor Signature and Date</h6>
                </div>
              </div>
            </td>
            <td>
              <div>
                <div class="space"><img :src="assessorFeedbackData.moderatorSignature" alt=""><p>{{displayDate(assessorFeedbackData.moderatorSignatureDate)}}</p></div>
                <div style="padding:5px; border-top:2px solid; border-bottom:2px solid;text-align:center" class="tableblue">
                  <h6>Moderator Signature and Date</h6>
                </div>
              </div>
            </td>
          </tr>
        </table>
      </div>
      <div :class="screenwidth > 850 ? 'w-full' :'vx-row w-full'" style="justify-content: space-between;">
        <p class="ml-3" style="align-self: center;" v-if="isStudent && screenwidth <= 850">Sign the Assessment Document <feather-icon icon="ArrowRightIcon" svgClasses="h-4 w-4"/></p>
        <vs-button id="btn-complete" color="success" v-if="!isStudent && !isModerator" class="mr-2 float-right" @click="closeTab">Complete</vs-button>
        <vs-button color="success" v-if="isStudent && !assessorFeedbackData.learnerSignature" :class="screenwidth > 850 ?  'float-right mr-2 mx-auto' : 'mr-2'" @click="signDocument">Sign</vs-button>
        <vs-button color="success" v-if="isModerator && !assessorFeedbackData.moderatorSignature" :class="screenwidth > 850 ?  'float-right mr-2 mx-auto' : 'mr-2'" @click="signDocumentModerator">Sign</vs-button>
      </div>
    </div>
  </div>
</template> 


<script>
import moment from 'moment'
export default {
  data() {
    return { 
      screenwidth: window.innerWidth,
    }
  },
  props:{
    assessorFeedbackData: {
      type: Object,
      required: true
    },
    taskResults: {
      required: false
    },
    questionList: {
      type: Array,
      required: false
    },
    assessorFeedback:{
      required: false
    },
    isStudent:{
      type: Boolean,
      required:false
    },
    isModerator:{
      type: Boolean,
      required:false
    },
  },
  components:{ 
    moment,
  },
  watch:{ 
    screenwidth(){

    }
  },
  computed: { 
    
  },
  methods: { 
    displayDate(date) {
      var self = this;
      if(date) {
        var dateString = new Date(Date.parse(date));
        var result = moment(dateString.toISOString()).format("dddd DD MMMM YYYY");
        return result;
      }
    },
    closeTab(){
      var self = this;
      self.$emit('closeTab');
    },
    onResize() {
      this.screenwidth = window.innerWidth;
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    signDocument(){
      var self = this;
      if(self.$hasSignature){
        self.showLoadingOnElement("AssessorFeedbackDocument",1,"corners");

        var onSuccess = response =>{
          if(self.$refs.AssessorFeedbackDocument){
            self.$vs.loading.close(self.$refs.AssessorFeedbackDocument.$el);
          }
          self.$emit('closeAssessorFeedbackDocument')
        }
      
        var onFinally = response =>{
          if(self.$refs.AssessorFeedbackDocument){
            self.$vs.loading.close(self.$refs.AssessorFeedbackDocument.$el);
          }
        }
      
        self.$ajaxGet(self, `assessorFeedback/SignDocument/${self.assessorFeedback.id}`  , onSuccess, onFinally);
      }
      else{
        self.$vs.notify({
          title:'Information',
          color: "danger",
          text: `Please Upload a Signature`,
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-save'
        });
      }
    },
    signDocumentModerator(){
      var self = this;
      if(self.$hasSignature){
        self.showLoadingOnElement("AssessorFeedbackDocument",1,"corners");

        var onSuccess = response =>{
          if(self.$refs.AssessorFeedbackDocument){
            self.$vs.loading.close(self.$refs.AssessorFeedbackDocument.$el);
          }
          self.$emit('closeAssessorFeedbackDocument')
        }
      
        var onFinally = response =>{
          if(self.$refs.AssessorFeedbackDocument){
            self.$vs.loading.close(self.$refs.AssessorFeedbackDocument.$el);
          }
        }
      
        self.$ajaxGet(self, `assessorFeedback/SignDocumentModerator/${self.assessorFeedback.id}`  , onSuccess, onFinally);
      }
      else{
        self.$vs.notify({
          title:'Information',
          color: "danger",
          text: `Please Upload a Signature`,
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-save'
        });
      }
    },
  },
  mounted(){
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    })
  }
}
</script>


<style lang="scss"> 
#AssessorFeedbackDocument{
  .Review-Dimensions{
    th{
      border-left:2px solid black ;
      border-right:2px solid black ;
      border-top:2px solid black ;
      background-color: #C6D9F1;
    }
    .Review-Dimensions-true{
      th{
        text-align:center;
      }
      tr:last-child{
        border: 2px solid black;
      }
      tr:not(:last-child){
        border: 2px solid black;
      }
      td:not(:first-child){
        border-left: 2px solid black;
      }
    }
    .first-header-data{
      padding: 5px;
      display:flex; 
    }
    .Review-Dimensions-free{
      

      tr{
        border: 2px solid black;
        td{
          padding: 5px;
        }
      }
      tr:first-child{
        border-top: 0px;
      }
    }
    
  }
  .outcome{
    width: 100%;
    border-bottom: 0px solid black;
    border-top: 2px solid black;
    border-left: 2px solid black;
    border-right: 2px solid black;
    .outcome-headers{
      width:150px;
      background-color: #C6D9F1;
      padding: 5px;
    }
    tr:last-child{
      border-bottom: 0px solid black;
    }
    tr:not(:last-child){
      td{
        border: 2px solid black;
      }
    }
    tr:last-child{
      td{
        border: 2px solid black;
        border-bottom: 0px ;
      }
    }
    
  }
  .tableblue{
    background-color: #C6D9F1;
  }
  .smallerWidth{
    width: 150px;
    min-width: 150px;
  }
  .darkblue{
    background-color: #8DB3E2;
  }
  .signature{
    height: 50px;
  }
  .competency{
    width: 65px;
    text-align: center;
  }
  .innertableData{
    td{
      padding:5px;
    }
  }

  .grid-container {
    display: grid;
    grid-template-columns: auto auto;
  }

  .grid-item {
    background-color: rgba(255, 255, 255, 0.8);
    text-align: center;
    border-bottom: 2px solid black;
    // border-left: 2px solid black;
  }
  .grid-item:nth-child(1){
    border-right: 2px solid black;
  }
  .grid-item:nth-child(3){
    border-right: 2px solid black;
    border-bottom: 0px solid black;
  }
  .grid-item:nth-child(4){
    border-bottom: 0px solid black;
  }

  .bottomborder{
    .lastrow{
      border-bottom: 2px solid black !important;
    }
  }
  .space,.signature{
    height: 85px;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    img{
      height: 100%;
      display: flex;
    }
  }
  .td-padding{
    td{
      padding:5px
    }
  }
}
#AssessorFeedbackDocument {
  * {
    color: #000000 !important;
  }
  .vs-popup {
    height: fit-content !important;
    background: #ffffff !important;
    color: #000000 !important;

    .vs-popup--content {
      overflow-x: auto !important;
    }

    .vs-popup--header {
      background: #d8d8d8 !important;

      .vs-popup--close--icon {
        background: rgb(255, 255, 255) !important;
        color: rgb(0, 0, 0) !important;
      }
    }
  }
}
</style>